export const TICKET_AI_REPORT_CREATED = "ticket-ai-report-created";

export const emitTicketAiReportCreated = (ticketId, report) => {
	window.dispatchEvent(
		new CustomEvent(TICKET_AI_REPORT_CREATED, {
			detail: { ticketId, report },
		})
	);
};
